import React from "react";

import {
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  InputAdornment,
  makeStyles,
  MenuItem,
  Popover,
  TextField,
  Typography,
} from "@material-ui/core";

import ExpandMoreOutlinedIcon from "@material-ui/icons/ExpandMoreOutlined";

import { LocationLoadType } from "../../../../utils/constants";

const useStyles = makeStyles((theme) => ({
  capacityInput: {
    margin: theme.spacing(1),
    minWidth: "8rem",
  },
  typeCapacityContainer: {
    margin: theme.spacing(2),
  },
}));

const getLoadTypes = (isBulk) => {
  if (isBulk) {
    return [
      {
        type: LocationLoadType.DRY_BULK,
        label: "Dry Bulk",
        hasCapacity: false,
      },
      {
        type: LocationLoadType.LIQUID_BULK,
        label: "Liquid Bulk",
        hasCapacity: false,
      },
      {
        type: LocationLoadType.CONTAINER,
        label: "Container",
        hasCapacity: false,
      },
    ];
  }
  return [
    { type: LocationLoadType.OTHER, label: "Other", hasCapacity: false },
    {
      type: LocationLoadType.CONTAINER,
      label: "Container",
      hasCapacity: false,
    },
    { type: LocationLoadType.PALLET, label: "Pallet", hasCapacity: true },
    { type: LocationLoadType.BOX, label: "Box", hasCapacity: true },
    {
      type: LocationLoadType.SUPERSACK,
      label: "Super Sack",
      hasCapacity: true,
    },
  ];
};

export const TypeCapacity = ({
  handleTypeCapacity,
  locationLoad,
  handleLocationLoadType,
  capacityList,
  getSelectedLoadTypes,
  bulk = false,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "capacity-popover" : undefined;

  const renderLoadType = (loadType) => (
    <FormGroup row key={loadType.type}>
      <FormControlLabel
        control={
          <Checkbox
            checked={locationLoad[loadType.type]?.selected}
            onChange={handleLocationLoadType}
            name={loadType.type}
          />
        }
        label={loadType.label}
        style={loadType.hasCapacity ? { width: "8rem" } : undefined}
      />
      {loadType.hasCapacity && (
        <TextField
          select
          name="typeCapacity"
          size="small"
          variant="outlined"
          onChange={(evt) =>
            handleTypeCapacity(evt.target.value, loadType.type)
          }
          value={locationLoad[loadType.type]?.capacity}
          className={classes.capacityInput}
          InputProps={{
            startAdornment: <InputAdornment position="start">%</InputAdornment>,
          }}
        >
          {capacityList.map((itm) => (
            <MenuItem key={itm} value={itm}>
              {itm}
            </MenuItem>
          ))}
        </TextField>
      )}
    </FormGroup>
  );

  return (
    <Grid container direction="column" spacing={0}>
      <Grid item xs={12}>
        <Button
          size="large"
          variant="outlined"
          onClick={handleClick}
          fullWidth
          endIcon={<ExpandMoreOutlinedIcon />}
        >
          Load Type
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="caption">
          {getSelectedLoadTypes(locationLoad)}
        </Typography>
      </Grid>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <FormGroup className={classes.typeCapacityContainer}>
          {getLoadTypes(bulk).map(renderLoadType)}
        </FormGroup>
      </Popover>
    </Grid>
  );
};
